import { __assign } from 'tslib';
import React__default from 'react';
import { navigationComponentsMap } from '@invitae/header-footer';
import { NucleobaseComponentMapContext } from '@invitae/nucleobase-core';

var NucleobaseCustomComponentsProvider = function (_a) {
    var nucleobaseConfig = _a.nucleobaseConfig, contentfulConfig = _a.contentfulConfig, children = _a.children;
    if (!nucleobaseConfig)
        return React__default.createElement(React__default.Fragment, null, children);
    if (nucleobaseConfig && !contentfulConfig) {
        console.error("NucleobaseCustomComponentsProvider - Missing `contentfulConfig` in NucleobaseShell. \n You can't use NucleobaseCustomComponentsProvider without defining `contentfulConfig`.");
        return React__default.createElement(React__default.Fragment, null, children);
    }
    var customComponentsMapWithNavigation = __assign(__assign({}, nucleobaseConfig === null || nucleobaseConfig === void 0 ? void 0 : nucleobaseConfig.customComponentsMap), navigationComponentsMap);
    return (React__default.createElement(NucleobaseComponentMapContext.Provider, { value: customComponentsMapWithNavigation }, children));
};

export { NucleobaseCustomComponentsProvider as default };
//# sourceMappingURL=NucleobaseCustomComponentsProvider.esm.js.map
